export const dashboardMock = {
	"status": "SUCCESS",
	"code": 200,
	"message": "Data retrieved successfully.",
	"data": {
		"results": {
			"dashboardId": 72,
			"datasourceId": 1530,
			"dashboardName": "Dashboard",
			"dashboardDescription": "Account description",
			"dashboardExecutionCount": 5,
			"isFavourite": 0,
			"dashboardSettings": "string",
			"dashboardConfig": [
				// {
				// 	"dashboardConfigId": 589,
				// 	"dashboardId": 72,
				// 	"reportId": 0,
				// 	"rows": 30,
				// 	"columns": 2,
				// 	"cardSettings": [] as any,
				// 	"cardType": "Annoucement",
				// 	"xposition": 0,
				// 	"yposition": 6,
				// },
				// {
				// 	"dashboardConfigId": 522,
				// 	"dashboardId": 72,
				// 	"reportId": 0,
				// 	"rows": 13,
				// 	"columns": 7,
				// 	"cardSettings": "",
				// 	"cardType": "meetingPortlet",
				// 	"xposition": 17,
				// 	"yposition": 8
				// }
			] as any[],
			"filterData": {
				enable: true,
				options: [
				  {
					label: 'First Name',
					field: 'firstName',
					type: 'text',
					data: [
					  {
						id: 1,
						value: 'test'
					  }
					]
				  },
				  {
					label: 'Last Name',
					field: 'lastName',
					type: 'text',
				  },
				  {
					label: 'Email',
					field: 'email',
					type: 'date',
				  },
				  {
					label: 'Created On',
					field: 'createdOn',
					type: 'date',
				  },
				],
			}
		}
	},
	"requestId": "370fffb1-a1b5-4f48-ad6f-8e7fdaaca2ef",
	"responseId": "87ec6403-421a-40e2-a55c-2ed8eceb3e0b",
	"timestamp": 1734700412.918031
}

export const GetTable = {
	id: "0",
	theme: "blue",
	noOfColumns: 6,
	checkboxSelect: "true",
	actionItem: "true",
	actionItemData: [
	  {
		actionId: "1",
		actionIcon: "edit",
		actionName: "Edit",
		actionTooltip: "Edit",
		showIcon: "true",
	  },
	  {
		actionId: "null",
		actionIcon: "delete",
		actionName: "Delete",
		actionTooltip: "Delete",
		showIcon: "true",
	  },
	  {
		actionId: "null",
		actionIcon: "lock_reset",
		actionName: "Reset Password",
		actionTooltip: "Reset password",
		showIcon: "true",
	  },
	  {
		actionId: "null",
		actionIcon: "reset_tv",
		actionName: "Reset eSign",
		actionTooltip: "Reset",
		showIcon: "true",
	  },
	  {
		actionId: "null",
		actionIcon: "task_alt",
		actionName: "Activate User",
		actionTooltip: "Activate User",
		showIcon: "true",
	  },
	],
	filter: "true",
	search: "true",
	pagination: "true",
	pin: "false",
	pinOnly: "false",
	commonTag: "[]",
	globalActionItem: [
	  {
		add: "false",
		delete: "true",
	  },
	],
	globalSearch: "true",
	columnManager: "true",
	columns: [
	  {
		columnsOnGrid: "true",
		columnCustomization: "true",
		mandColumns: "true",
		type: "string",
		showColumn: "true",
		list: "null",
		textAlign: "left",
		showFilter: "true",
		filterData: "[]",
		colorCondition: "[]",
		sequenceNumber: "0",
		ColName: "checkbox",
		label: "checkbox",
		dataFormat: "",
	  },
	  {
		columnsOnGrid: "true",
		columnCustomization: "true",
		mandColumns: "true",
		type: "string",
		showColumn: "true",
		list: "null",
		textAlign: "left",
		showFilter: "true",
		filterData: "[]",
		colorCondition: "[]",
		sequenceNumber: "1",
		ColName: "loginName",
		label: "User Name",
		dataFormat: "link",
	  },
	  {
		columnsOnGrid: "true",
		columnCustomization: "true",
		mandColumns: "true",
		type: "string",
		showColumn: "true",
		list: "null",
		textAlign: "left",
		showFilter: "true",
		filterData: "[]",
		colorCondition: "[]",
		sequenceNumber: "2",
		ColName: "firstName",
		label: "First Name",
		dataFormat: "",
	  },
	  {
		columnsOnGrid: "true",
		columnCustomization: "true",
		mandColumns: "true",
		type: "string",
		showColumn: "true",
		list: "null",
		textAlign: "left",
		showFilter: "true",
		filterData: "[]",
		colorCondition: "[]",
		sequenceNumber: "3",
		ColName: "lastName",
		label: "Last Name",
		dataFormat: "",
	  },
	  {
		columnsOnGrid: "true",
		columnCustomization: "true",
		mandColumns: "true",
		type: "string",
		showColumn: "true",
		list: "null",
		textAlign: "left",
		showFilter: "true",
		filterData: "[]",
		colorCondition: "[]",
		sequenceNumber: "4",
		ColName: "email",
		label: "Email",
		dataFormat: "",
	  },
	  {
		columnsOnGrid: "true",
		columnCustomization: "true",
		mandColumns: "true",
		type: "string",
		showColumn: "true",
		list: "null",
		textAlign: "left",
		showFilter: "true",
		filterData: "[]",
		colorCondition: "[]",
		sequenceNumber: "5",
		ColName: "userStatusMessage",
		label: "Reason for Inactivity",
		dataFormat: "",
	  },
	  {
		columnsOnGrid: "true",
		columnCustomization: "true",
		mandColumns: "true",
		type: "string",
		showColumn: "true",
		list: "null",
		textAlign: "left",
		showFilter: "true",
		filterData: "[]",
		colorCondition: "[]",
		sequenceNumber: "6",
		ColName: "tableActionItems",
		label: "Action Items",
		dataFormat: "",
	  },
	],
	data: [
		{
            "pk_userID": 484,
            "loginName": "A.Administrator",
            "firstName": "Muthu",
            "lastName": "Krish",
            "email": "vjayaprakash@chn.aithent.com",
            "phone": "+918072484263",
            "userIsActive": 1,
            "user_AccIsActive": 1,
            "userAccountStatus": 1,
            "userStatusMessage": "Login attempts failed.",
            "groups": null,
            "contentType": null
        },
        {
            "pk_userID": 33423,
            "loginName": "Anitha",
            "firstName": "Anitha",
            "lastName": "Ani",
            "email": "anitha@gmail.com",
            "phone": "9978989979",
            "userAccountStatus": 4,
            "userStatusMessage": "Password has expired.",
            "groups": null,
            "contentType": null
        },
        {
            "pk_userID": 33524,
            "loginName": "ooviya",
            "firstName": "Muthu",
            "lastName": "Krishnan",
            "email": "testmail@gmail.com",
            "phone": "9090608080",
            "userIsActive": 1,
            "user_AccIsActive": 1,
            "userAccountStatus": 4,
            "userStatusMessage": "Password has expired.",
            "groups": null,
            "contentType": null
        },
        {
            "pk_userID": 33701,
            "loginName": "Admin353",
            "firstName": "Admin",
            "lastName": "AD",
            "email": "new@user.com",
            "phone": "9908909088",
            "userIsActive": 1,
            "user_AccIsActive": 1,
            "userAccountStatus": 4,
            "userStatusMessage": "Password has expired.",
            "groups": null,
            "contentType": null
        },
        {
            "pk_userID": 33728,
            "loginName": "annisi1",
            "firstName": "Anny",
            "lastName": "Bent",
            "email": "eoviya@chn.aithent.com",
            "phone": "9090608080",
            "userAccountStatus": 0,
            "userStatusMessage": "Unknown status. Please contact support.",
            "groups": null,
            "contentType": null
        },
        {
            "pk_userID": 33730,
            "loginName": "Prenika",
            "firstName": "Muthu",
            "lastName": "Krishnan",
            "email": "eoviya@chn.aithent.com",
            "phone": "9199423172",
            "user_AccIsActive": 1,
            "userAccountStatus": 1,
            "userStatusMessage": "Login attempts failed.",
            "groups": null,
            "contentType": null
        }
	],
};

export const tableData1 = {
	id: "1",
	theme: "blue",
	noOfColumns: 6,
	checkboxSelect: "true",
	actionItem: "true",
	actionItemData: [
	  {
		actionId: "1",
		actionIcon: "edit",
		actionName: "Edit",
		actionTooltip: "Edit",
		showIcon: "true",
	  },
	  {
		actionId: "null",
		actionIcon: "delete",
		actionName: "Delete",
		actionTooltip: "Delete",
		showIcon: "true",
	  },
	],
	filter: "true",
	search: "true",
	pagination: "true",
	pin: "false",
	pinOnly: "false",
	commonTag: "[]",
	globalActionItem: [
	  {
		add: "false",
		delete: "true",
	  },
	],
	globalSearch: "true",
	columnManager: "true",
	columns: [
	  {
		columnsOnGrid: "true",
		columnCustomization: "true",
		mandColumns: "true",
		type: "string",
		showColumn: "true",
		list: "null",
		textAlign: "left",
		showFilter: "true",
		filterData: "[]",
		colorCondition: "[]",
		sequenceNumber: "0",
		ColName: "checkbox",
		label: "checkbox",
		dataFormat: "",
	  },
	  {
		columnsOnGrid: "true",
		columnCustomization: "true",
		mandColumns: "true",
		type: "string",
		showColumn: "true",
		list: "null",
		textAlign: "left",
		showFilter: "true",
		filterData: "[]",
		colorCondition: "[]",
		sequenceNumber: "1",
		ColName: "loginName",
		label: "User Name",
		dataFormat: "link",
	  },
	  {
		columnsOnGrid: "true",
		columnCustomization: "true",
		mandColumns: "true",
		type: "string",
		showColumn: "true",
		list: "null",
		textAlign: "left",
		showFilter: "true",
		filterData: "[]",
		colorCondition: "[]",
		sequenceNumber: "2",
		ColName: "firstName",
		label: "First Name",
		dataFormat: "",
	  },
	  {
		columnsOnGrid: "true",
		columnCustomization: "true",
		mandColumns: "true",
		type: "string",
		showColumn: "true",
		list: "null",
		textAlign: "left",
		showFilter: "true",
		filterData: "[]",
		colorCondition: "[]",
		sequenceNumber: "3",
		ColName: "lastName",
		label: "Last Name",
		dataFormat: "",
	  },
	  {
		columnsOnGrid: "true",
		columnCustomization: "true",
		mandColumns: "true",
		type: "string",
		showColumn: "true",
		list: "null",
		textAlign: "left",
		showFilter: "true",
		filterData: "[]",
		colorCondition: "[]",
		sequenceNumber: "4",
		ColName: "email",
		label: "Email",
		dataFormat: "",
	  },
	  {
		columnsOnGrid: "true",
		columnCustomization: "true",
		mandColumns: "true",
		type: "string",
		showColumn: "true",
		list: "null",
		textAlign: "left",
		showFilter: "true",
		filterData: "[]",
		colorCondition: "[]",
		sequenceNumber: "5",
		ColName: "tableActionItems",
		label: "Action Items",
		dataFormat: "",
	  },
	],
	data: [
		{
			loginName: 'Test1',
			firstName: 'Test',
			lastName: '1',
			email: 'test1@gamil.com'
		},
		{
			loginName: 'Test2',
			firstName: 'Test',
			lastName: '2',
			email: 'test2@gamil.com'
		},
		{
			loginName: 'Test3',
			firstName: 'Test',
			lastName: '3',
			email: 'test3@gamil.com'
		},
		{
			loginName: 'Test4',
			firstName: 'Test',
			lastName: '4',
			email: 'test4@gamil.com'
		},
		{
			loginName: 'Test5',
			firstName: 'Test',
			lastName: '5',
			email: 'test5@gamil.com'
		},
	],
}

export const tableData2 = {
	id: "2",
	theme: "blue",
	noOfColumns: 6,
	checkboxSelect: "true",
	actionItem: "true",
	actionItemData: [
	  {
		actionId: "1",
		actionIcon: "edit",
		actionName: "Edit",
		actionTooltip: "Edit",
		showIcon: "true",
	  },
	  {
		actionId: "null",
		actionIcon: "delete",
		actionName: "Delete",
		actionTooltip: "Delete",
		showIcon: "true",
	  },
	],
	filter: "true",
	search: "true",
	pagination: "true",
	pin: "false",
	pinOnly: "false",
	commonTag: "[]",
	globalActionItem: [
	  {
		add: "false",
		delete: "true",
	  },
	],
	globalSearch: "true",
	columnManager: "true",
	columns: [
	  {
		columnsOnGrid: "true",
		columnCustomization: "true",
		mandColumns: "true",
		type: "string",
		showColumn: "true",
		list: "null",
		textAlign: "left",
		showFilter: "true",
		filterData: "[]",
		colorCondition: "[]",
		sequenceNumber: "0",
		ColName: "checkbox",
		label: "checkbox",
		dataFormat: "",
	  },
	  {
		columnsOnGrid: "true",
		columnCustomization: "true",
		mandColumns: "true",
		type: "string",
		showColumn: "true",
		list: "null",
		textAlign: "left",
		showFilter: "true",
		filterData: "[]",
		colorCondition: "[]",
		sequenceNumber: "1",
		ColName: "column1",
		label: "Column 1",
		dataFormat: "link",
	  },
	  {
		columnsOnGrid: "true",
		columnCustomization: "true",
		mandColumns: "true",
		type: "string",
		showColumn: "true",
		list: "null",
		textAlign: "left",
		showFilter: "true",
		filterData: "[]",
		colorCondition: "[]",
		sequenceNumber: "2",
		ColName: "column2",
		label: "Column 2",
		dataFormat: "",
	  },
	  {
		columnsOnGrid: "true",
		columnCustomization: "true",
		mandColumns: "true",
		type: "string",
		showColumn: "true",
		list: "null",
		textAlign: "left",
		showFilter: "true",
		filterData: "[]",
		colorCondition: "[]",
		sequenceNumber: "3",
		ColName: "column3",
		label: "Column 3",
		dataFormat: "",
	  },
	  {
		columnsOnGrid: "true",
		columnCustomization: "true",
		mandColumns: "true",
		type: "string",
		showColumn: "true",
		list: "null",
		textAlign: "left",
		showFilter: "true",
		filterData: "[]",
		colorCondition: "[]",
		sequenceNumber: "4",
		ColName: "column4",
		label: "Column 4",
		dataFormat: "",
	  },
	  {
		columnsOnGrid: "true",
		columnCustomization: "true",
		mandColumns: "true",
		type: "string",
		showColumn: "true",
		list: "null",
		textAlign: "left",
		showFilter: "true",
		filterData: "[]",
		colorCondition: "[]",
		sequenceNumber: "5",
		ColName: "tableActionItems",
		label: "Action Items",
		dataFormat: "",
	  },
	],
	data: [
		{
			column1: 'Column 1 Data 1',
			column2: 'Column 2 Data 1',
			column3: 'Column 3 Data 1',
			column4: 'Column 4 Data 1'
		},
		{
			column1: 'Column 1 Data 2',
			column2: 'Column 2 Data 2',
			column3: 'Column 3 Data 2',
			column4: 'Column 4 Data 2'
		},
		{
			column1: 'Column 1 Data 3',
			column2: 'Column 2 Data 3',
			column3: 'Column 3 Data 3',
			column4: 'Column 4 Data 3'
		},
		{
			column1: 'Column 1 Data 4',
			column2: 'Column 2 Data 4',
			column3: 'Column 3 Data 4',
			column4: 'Column 4 Data 4'
		},
		{
			column1: 'Column 1 Data 5',
			column2: 'Column 2 Data 5',
			column3: 'Column 3 Data 5',
			column4: 'Column 4 Data 5'
		},
	],
}

export const chipData1 = [
	{
		id:1,
		name: 'Test1',
		label: 'Test1',
		count: 5,
		color:"maroon",
	},
	{
		id:2,
		name: 'Test2',
		label: 'Test2',
		count: 6,
		color:"green",
	},
	{
		id:1,
		name: 'Test1',
		label: 'Test1',
		count: 5,
		color:"maroon",
	},
	{
		id:2,
		name: 'Test2',
		label: 'Test2',
		count: 6,
		color:"green",
	},
	{
		id:1,
		name: 'Test1',
		label: 'Test1',
		count: 5,
		color:"maroon",
	},
	{
		id:2,
		name: 'Test2',
		label: 'Test2',
		count: 6,
		color:"green",
	}
];

export const chipData2 = [
	{
		id:1,
		name: 'Test3',
		label: 'DeactivatedUSrCount',
		count: 3,
		color:"maroon",
	},
	{
		id:2,
		name: 'Test4',
		label: 'Test4',
		count: 1,
		color:"green",
	}
]

// export const tableData1 = {
// 	id: "0",
// 	theme: "blue",
// 	noOfColumns: 6,
// 	checkboxSelect: "true",
// 	actionItem: "true",
// 	actionItemData: [
// 	  {
// 		actionId: "1",
// 		actionIcon: "edit",
// 		actionName: "Edit",
// 		actionTooltip: "Edit",
// 		showIcon: "true",
// 	  },
// 	  {
// 		actionId: "null",
// 		actionIcon: "delete",
// 		actionName: "Delete",
// 		actionTooltip: "Delete",
// 		showIcon: "true",
// 	  },
// 	],
// 	filter: "true",
// 	search: "true",
// 	pagination: "true",
// 	pin: "false",
// 	pinOnly: "false",
// 	commonTag: "[]",
// 	globalActionItem: [
// 	  {
// 		add: "false",
// 		delete: "true",
// 	  },
// 	],
// 	globalSearch: "true",
// 	columnManager: "true",
// 	columns: [
// 	  {
// 		columnsOnGrid: "true",
// 		columnCustomization: "true",
// 		mandColumns: "true",
// 		type: "string",
// 		showColumn: "true",
// 		list: "null",
// 		textAlign: "left",
// 		showFilter: "true",
// 		filterData: "[]",
// 		colorCondition: "[]",
// 		sequenceNumber: "0",
// 		ColName: "checkbox",
// 		label: "checkbox",
// 		dataFormat: "",
// 	  },
// 	  {
// 		columnsOnGrid: "true",
// 		columnCustomization: "true",
// 		mandColumns: "true",
// 		type: "string",
// 		showColumn: "true",
// 		list: "null",
// 		textAlign: "left",
// 		showFilter: "true",
// 		filterData: "[]",
// 		colorCondition: "[]",
// 		sequenceNumber: "1",
// 		ColName: "loginName",
// 		label: "User Name",
// 		dataFormat: "link",
// 	  },
// 	  {
// 		columnsOnGrid: "true",
// 		columnCustomization: "true",
// 		mandColumns: "true",
// 		type: "string",
// 		showColumn: "true",
// 		list: "null",
// 		textAlign: "left",
// 		showFilter: "true",
// 		filterData: "[]",
// 		colorCondition: "[]",
// 		sequenceNumber: "2",
// 		ColName: "firstName",
// 		label: "First Name",
// 		dataFormat: "",
// 	  },
// 	  {
// 		columnsOnGrid: "true",
// 		columnCustomization: "true",
// 		mandColumns: "true",
// 		type: "string",
// 		showColumn: "true",
// 		list: "null",
// 		textAlign: "left",
// 		showFilter: "true",
// 		filterData: "[]",
// 		colorCondition: "[]",
// 		sequenceNumber: "3",
// 		ColName: "lastName",
// 		label: "Last Name",
// 		dataFormat: "",
// 	  },
// 	  {
// 		columnsOnGrid: "true",
// 		columnCustomization: "true",
// 		mandColumns: "true",
// 		type: "string",
// 		showColumn: "true",
// 		list: "null",
// 		textAlign: "left",
// 		showFilter: "true",
// 		filterData: "[]",
// 		colorCondition: "[]",
// 		sequenceNumber: "4",
// 		ColName: "email",
// 		label: "Email",
// 		dataFormat: "",
// 	  },
// 	  {
// 		columnsOnGrid: "true",
// 		columnCustomization: "true",
// 		mandColumns: "true",
// 		type: "string",
// 		showColumn: "true",
// 		list: "null",
// 		textAlign: "left",
// 		showFilter: "true",
// 		filterData: "[]",
// 		colorCondition: "[]",
// 		sequenceNumber: "5",
// 		ColName: "tableActionItems",
// 		label: "Action Items",
// 		dataFormat: "",
// 	  },
// 	],
// 	data: [
// 		{
// 			loginName: 'Test1',
// 			firstName: 'Test',
// 			lastName: '1',
// 			email: 'test1@gamil.com'
// 		},
// 		{
// 			loginName: 'Test2',
// 			firstName: 'Test',
// 			lastName: '2',
// 			email: 'test2@gamil.com'
// 		},
// 		{
// 			loginName: 'Test3',
// 			firstName: 'Test',
// 			lastName: '3',
// 			email: 'test3@gamil.com'
// 		},
// 		{
// 			loginName: 'Test4',
// 			firstName: 'Test',
// 			lastName: '4',
// 			email: 'test4@gamil.com'
// 		},
// 		{
// 			loginName: 'Test5',
// 			firstName: 'Test',
// 			lastName: '5',
// 			email: 'test5@gamil.com'


export const meeting_dataSources = {
    id: 1,
    theme: "blue",
    noOfColumns: 6,
    actionItem: true,
    rowId: 'pK_ProviderID',
    iconAbsolute: true,
    actionItemData: [
      {
        actionId: "1",
        actionIcon: "edit",
        actionName: "Edit",
        actionTooltip: "Edit",
        showIcon: true,
      },
    ],
    filter: 'true',
    search: 'true',
    pagination: 'true',
    globalActionItem: [
      {
        edit: 'true',
        add: 'true',
        delete: 'false'
      }
    ],
    globalSearch: 'true',
    columnManager: 'true',
    columnEdit: [
      {
   
      }
    ],
    pin: true,
    pinOnly: true,
    commonTag: [],
    columns: [
      {
        sequenceNumber: 1,
        id: 1,
        ColName: "MEETING_DATE",
        label: "Meeting Date",
        columnsOnGrid: true,
        columnCustomization: true,
        mandColumns: true,
        type: "string",
        list: null,
        textAlign: "left",
        showColumn: true,
        dataFormat: "",
        inputFormat: "text",
        showFilter: true,
      },
      {
        sequenceNumber: 2,
        id: 2,
        ColName: "MEETING_TITLE",
        label: "Meetig Title",
        columnsOnGrid: true,
        columnCustomization: true,
        mandColumns: true,
        type: "string",
        list: null,
        textAlign: "left",
        showColumn: true,
        dataFormat: "link",
        inputFormat: "text",
        showFilter: true,
      },
      {
        sequenceNumber: 3,
        id: 3,
        ColName: "FACILITATOR",
        label: "Facilitator",
        columnsOnGrid: true,
        columnCustomization: true,
        mandColumns: true,
        type: "string",
        list: null,
        textAlign: "left",
        showColumn: true,
        dataFormat: "titlecase",
        inputFormat: "text",
        showFilter: false,
      },{
	  sequenceNumber: 4,
        id: 4,
        ColName: "ATTENDEE_NAME_GROUP",
        label: "Attendee",
        columnsOnGrid: true,
        columnCustomization: true,
        mandColumns: true,
        type: "string",
        list: null,
        textAlign: "left",
        showColumn: true,
        dataFormat: "titlecase",
        inputFormat: "text",
        showFilter: false,
      }
      // {
      //   sequenceNumber: 4,
      //   id: 4,
      //   ColName: "providerCity",
      //   label: "City1234",
      //   columnsOnGrid: true,
      //   columnCustomization: true,
      //   mandColumns: true,
      //   type: "string",
      //   list: null,
      //   textAlign: "left",
      //   showColumn: true,
      //   dataFormat: "",
      //   inputFormat: "dropdown",
      //   showFilter: falsepdash,
      //   dropdownValues: ['NEW YORK', 'BROOKLYN', 'GREAT NECK', 'ELMWOOD PARK', 'BRONX', 'JAMAICA', 'FLUSHING']
      // },
      // {
      //   sequenceNumber: 5,
      //   id: 5,
      //   ColName: "providerState",
      //   label: "State",
      //   columnsOnGrid: true,
      //   columnCustomization: true,
      //   mandColumns: true,
      //   type: "button",
      //   list: null,
      //   textAlign: "left",
      //   dataFormat: "",
      //   inputFormat: "text",
      //   showColumn: true,
      //   filterData: [],
      // },
      // {
      //   sequenceNumber: 6,
      //   id: 6,
      //   ColName: "tableActionItems",
      //   label: "Action Items",
      //   columnsOnGrid: true,
      //   columnCustomization: true,
      //   mandColumns: true,
      //   type: "button",
      //   list: null,
      //   textAlign: "left",
      //   dataFormat: "titlecase",
      //   inputFormat: "text",
      //   showColumn: true,
      //   filterData: [],
      // }
    ],
    data: [
    //   { MEETING_DATE: "01/02/2025 00:00:00", MEETING_TITLE: "Test Meeting", FACILITATOR: "Ramya Raja" },
    //   { MEETING_DATE: "01/02/2025 00:00:00", MEETING_TITLE: "Test Meeting notes", FACILITATOR: "Ramya Raja" },
    //   { MEETING_DATE: "01/03/2025 00:00:00", MEETING_TITLE: "User max rights", FACILITATOR: "Saranraj M w" },
    //   { MEETING_DATE: "01/03/2025 00:00:00", MEETING_TITLE: "New task Meeting", FACILITATOR: "Srikanth Talari" },
    //   { MEETING_DATE: "01/04/2025 00:00:00", MEETING_TITLE: "Project Update", FACILITATOR: "John Doe" },
    //   { MEETING_DATE: "01/04/2025 00:00:00", MEETING_TITLE: "Client Call", FACILITATOR: "Jane Smith" }
    ],
    // totalRecords: 50,
    // totalRecordsFound: 50,
  };


  export const task_dataSources = {
    id: 1,
    theme: "blue",
    noOfColumns: 6,
    actionItem: true,
    rowId: 'pK_ProviderID',
    iconAbsolute: true,
    actionItemData: [
      {
        actionId: "1",
        actionIcon: "edit",
        actionName: "Edit",
        actionTooltip: "Edit",
        showIcon: true,
      },
    ],
    filter: 'true',
    search: 'true',
    pagination: 'true',
    globalActionItem: [
      {
        edit: 'true',
        add: 'true',
        delete: 'false'
      }
    ],
    globalSearch: 'true',
    columnManager: 'true',
    columnEdit: [
      {
   
      }
    ],
    pin: true,
    pinOnly: true,
    commonTag: [],
    columns: [
      {
        sequenceNumber: 1,
        id: 1,
        ColName: "DUEDATE",
        label: "Due Date",
        columnsOnGrid: true,
        columnCustomization: true,
        mandColumns: true,
        type: "string",
        list: null,
        textAlign: "left",
        showColumn: true,
        dataFormat: "link",
        inputFormat: "text",
        showFilter: true,
      },
      {
        sequenceNumber: 2,
        id: 2,
        ColName: "TASKTITLE",
        label: "Task Title",
        columnsOnGrid: true,
        columnCustomization: true,
        mandColumns: true,
        type: "string",
        list: null,
        textAlign: "left",
        showColumn: true,
        dataFormat: "",
        inputFormat: "text",
        showFilter: true,
      },
      {
        sequenceNumber: 3,
        id: 3,
        ColName: "ASSIGNEDTO",
        label: "Assigned To",
        columnsOnGrid: true,
        columnCustomization: true,
        mandColumns: true,
        type: "string",
        list: null,
        textAlign: "left",
        showColumn: true,
        dataFormat: "titlecase",
        inputFormat: "text",
        showFilter: false,
      }
      // {
      //   sequenceNumber: 4,
      //   id: 4,
      //   ColName: "providerCity",
      //   label: "City1234",
      //   columnsOnGrid: true,
      //   columnCustomization: true,
      //   mandColumns: true,
      //   type: "string",
      //   list: null,
      //   textAlign: "left",
      //   showColumn: true,
      //   dataFormat: "",
      //   inputFormat: "dropdown",
      //   showFilter: false,
      //   dropdownValues: ['NEW YORK', 'BROOKLYN', 'GREAT NECK', 'ELMWOOD PARK', 'BRONX', 'JAMAICA', 'FLUSHING']
      // },
      // {
      //   sequenceNumber: 5,
      //   id: 5,
      //   ColName: "providerState",
      //   label: "State",
      //   columnsOnGrid: true,
      //   columnCustomization: true,
      //   mandColumns: true,
      //   type: "button",
      //   list: null,
      //   textAlign: "left",
      //   dataFormat: "",
      //   inputFormat: "text",
      //   showColumn: true,
      //   filterData: [],
      // },
      // {
      //   sequenceNumber: 6,
      //   id: 6,
      //   ColName: "tableActionItems",
      //   label: "Action Items",
      //   columnsOnGrid: true,
      //   columnCustomization: true,
      //   mandColumns: true,
      //   type: "button",
      //   list: null,
      //   textAlign: "left",
      //   dataFormat: "titlecase",
      //   inputFormat: "text",
      //   showColumn: true,
      //   filterData: [],
      // }
    ],
    data: [
     {}
    ],
    // totalRecords: 50,
    // totalRecordsFound: 50,
  };

  export const form_dataSources = {
    id: 1,
    theme: "blue",
    noOfColumns: 6,
    actionItem: true,
    rowId: 'pK_ProviderID',
    iconAbsolute: true,
    actionItemData: [
      {
        actionId: "1",
        actionIcon: "edit",
        actionName: "Edit",
        actionTooltip: "Edit",
        showIcon: true,
      },
    ],
    filter: 'true',
    search: 'true',
    pagination: 'true',
    globalActionItem: [
      {
        edit: 'true',
        add: 'true',
        delete: 'false'
      }
    ],
    globalSearch: 'true',
    columnManager: 'true',
    columnEdit: [
      {
   
      }
    ],
    pin: true,
    pinOnly: true,
    commonTag: [],
    columns: [
      {
        sequenceNumber: 1,
        id: 1,
        ColName: "formName",
        label: "Form Name",
        columnsOnGrid: true,
        columnCustomization: true,
        mandColumns: true,
        type: "string",
        list: null,
        textAlign: "left",
        showColumn: true,
        dataFormat: "link",
        inputFormat: "text",
        showFilter: true,
      }
      // {
      //   sequenceNumber: 4,
      //   id: 4,
      //   ColName: "providerCity",
      //   label: "City1234",
      //   columnsOnGrid: true,
      //   columnCustomization: true,
      //   mandColumns: true,
      //   type: "string",
      //   list: null,
      //   textAlign: "left",
      //   showColumn: true,
      //   dataFormat: "",
      //   inputFormat: "dropdown",
      //   showFilter: false,
      //   dropdownValues: ['NEW YORK', 'BROOKLYN', 'GREAT NECK', 'ELMWOOD PARK', 'BRONX', 'JAMAICA', 'FLUSHING']
      // },
      // {
      //   sequenceNumber: 5,
      //   id: 5,
      //   ColName: "providerState",
      //   label: "State",
      //   columnsOnGrid: true,
      //   columnCustomization: true,
      //   mandColumns: true,
      //   type: "button",
      //   list: null,
      //   textAlign: "left",
      //   dataFormat: "",
      //   inputFormat: "text",
      //   showColumn: true,
      //   filterData: [],
      // },
      // {
      //   sequenceNumber: 6,
      //   id: 6,
      //   ColName: "tableActionItems",
      //   label: "Action Items",
      //   columnsOnGrid: true,
      //   columnCustomization: true,
      //   mandColumns: true,
      //   type: "button",
      //   list: null,
      //   textAlign: "left",
      //   dataFormat: "titlecase",
      //   inputFormat: "text",
      //   showColumn: true,
      //   filterData: [],
      // }
    ],
    data: [
     {}
    ],
    // totalRecords: 50,
    // totalRecordsFound: 50,
  };

